import { useState, useEffect } from "react";

import { Box, Tooltip, ToggleButtonGroup, Typography } from "@mui/material";
import { BarChart, Timeline } from '@mui/icons-material';

import { withTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { isNull } from "lodash";

import { StyledToggleButton } from "@plannel/components/ui/ToggleButton";
import reduxUtil from "@plannel/utils/redux-util";
import { FS } from "@plannel/utils/font-util";

const ToggleButtons = (props) => {
  const { t, viewName, toggleType, toggleValue, initialValue, options, styles = {}, isProfit = false } = props;
  const [alignment, setAlignment] = useState(initialValue ? initialValue : toggleType === "measure" ? 'amt' : 'bar');

  const reduxDispatch = useDispatch();

  const handleAlignment = (_, newAlignment) => {
    if (!isNull(newAlignment)) {
      setAlignment(newAlignment);
      toggleValue(newAlignment);

      if (viewName) {
        const reduxState = reduxUtil.createObjectState(viewName, { toggle: newAlignment });
        reduxDispatch(reduxUtil.updateViewState(reduxState));
      }
    }
  };

  useEffect(() => {
    if (initialValue) {
      setAlignment(initialValue);
    }
  }, [initialValue]);

  return (
    <Box id={"toggle-button-group"} sx={{ ml: "auto", flex: "none", float: "right", mt: 1, height: options?.height, ...styles }}>
      {toggleType === "measure" ?
        <ToggleButtonGroup
          size="small"
          value={alignment}
          exclusive
          onChange={handleAlignment}
          aria-label="text alignment">
          <StyledToggleButton sx={{ width: "50px", height: "30px" }} value="amt" aria-label="amt">
            <Typography varient="subtitle2" sx={{ width: "50px", fontSize: FS.H2 }} >{t("amt")}</Typography>
          </StyledToggleButton>
          <StyledToggleButton sx={{ width: "50px", height: "30px" }} value="qty" aria-label="qty">
            <Typography varient="subtitle2" sx={{ width: "50px", fontSize: FS.H2 }} >{t("qty")}</Typography>
          </StyledToggleButton>
          { isProfit ?
            <StyledToggleButton sx={{ width: "70px", height: "30px" }} value="profit" aria-label="profit">
              <Typography varient="subtitle2" sx={{ width: "70px", fontSize: FS.H2 }} >{t("profit")}</Typography>
            </StyledToggleButton>
          : null }
        </ToggleButtonGroup> 
        : <ToggleButtonGroup
          size="small"
          value={alignment}
          exclusive
          onChange={handleAlignment}
          aria-label="text alignment">
          <StyledToggleButton sx={{ width: "30px", height: "30px" }} value="bar" aria-label="bar">
            <Tooltip title={t("bar")}>
              <BarChart size="small" />
            </Tooltip>
          </StyledToggleButton>
          <StyledToggleButton sx={{ width: "30px", height: "30px" }} value="line" aria-label="line">
            <Tooltip title={t("line")}>
              <Timeline size="small" />
            </Tooltip>
          </StyledToggleButton>
        </ToggleButtonGroup>}
    </Box>
  );
}
export default withTranslation()(ToggleButtons);